var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Collection from "../Collection";
import LocationSampleModel from "../../models/LocationSampleModel";
import * as atlas from "azure-maps-control";
var BoundingBox = atlas.data.BoundingBox;
/**
 *
 */
var LocationSampleCollection = /** @class */ (function (_super) {
    __extends(LocationSampleCollection, _super);
    /**
     *
     */
    function LocationSampleCollection() {
        return _super.call(this, LocationSampleModel) || this;
    }
    LocationSampleCollection.prototype.getLocationSamplesForAsset = function (assetMetricsId) {
        return this.list.filter(function (locationSampleModel) { return locationSampleModel.assetMetricsId === assetMetricsId; });
    };
    /**
     *
     * @return {atlas.data.BoundingBox}
     */
    LocationSampleCollection.prototype.getBoundingBoxForAsset = function (assetMetricsId) {
        var locations = this.getLocationSamplesForAsset(assetMetricsId);
        var positions = [];
        locations.forEach(function (locationSampleModel) {
            positions.push(locationSampleModel.getFirstCoordinates());
            positions.push(locationSampleModel.getLastCoordinates());
        });
        return BoundingBox.fromPositions(positions.filter(function (position) { return position != null; }));
    };
    /**
     *
     */
    LocationSampleCollection.prototype.getCoordinatesArray = function () {
        var coordinates = [];
        this.list.forEach(function (locationSample) {
            if (locationSample.isCoordinate()) {
                coordinates.push({ longitude: locationSample.firstLong, latitude: locationSample.firstLat });
                coordinates.push({ longitude: locationSample.lastLong, latitude: locationSample.lastLat });
            }
        });
        return coordinates;
    };
    return LocationSampleCollection;
}(Collection));
export default LocationSampleCollection;
